import { injectable } from '@servicetitan/react-ioc';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { AuthApi } from '@servicetitan/task-hub-api';

@injectable()
export class AppStore {
    @observable initialized = false;
    @observable loading = false;
    @observable authorized = false;
    @observable username = '';
    @observable orgId: string | undefined;

    constructor(private readonly authApi: AuthApi) {
        makeObservable(this);
    }

    @action
    initApp = async () => {
        if (!this.initialized) {
            this.initialized = true;
        }
        if (this.loading) {
            return;
        }

        this.loading = true;

        try {
            const authInfo = (await this.authApi.getInfo({ apiVersion: '1.0' })).data;
            runInAction(() => {
                this.authorized = true;
                this.orgId = authInfo.orgId;
                this.username = authInfo.userName ?? '';
            });
        } catch {
            runInAction(() => {
                this.authorized = false;
            });
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    };
}
